import {Table} from '@tiptap/extension-table';
import TableCell from '@tiptap/extension-table-cell';
import TableHeader from '@tiptap/extension-table-header';
import TableRow from '@tiptap/extension-table-row';
import {TableCellBackgroundColor} from '../tiptap-extension/CellBackgroundColor';

export const CustomTable = Table.extend({
    renderHTML({HTMLAttributes}) {
        return ['table', HTMLAttributes, ['tbody', 0]];
    },
});

export const tableExtensions = [CustomTable, TableRow, TableHeader, TableCell, TableCellBackgroundColor];
